module.exports = __webpack_public_path__ + "media/ness.edd98e22.wav";